kombi.search = function () {
    const MAX = {
        ROOMS: 5,
        ADULTS: 10,
        CHILDREN: 5,
        PACKAGE_GUESTS: 9
    };
    const MIN = {
        ROOMS: 1,
        ADULTS: 1,
        CHILDREN: 0
    };

    const SELECTORS = {
        GUEST_FORM_CONTAINER: '.room-container',
        ROOM_SELECTION_CARD: '.room',
        SEARCH_WIDGET_WRAPPER: '.guest-selector-wrapper, .guest-selector-dropdown, .guest-selector-dropdown-desktop, .guests',
        TRAVELER_SUMMARY: '#search-travelers-desk, .block-guests.guests',
        ADULT_INPUT: 'input[name="adults"]',
        CHILD_INPUT: 'input[name="children"]',
        AGE_OF_CHILDREN: 'input[name="age_of_children"]',
        CHILD_TOOLTIP: '.children-tooltip[data-bs-toggle="tooltip"]',
        ROOM_COUNT_INPUT: 'input.number_of_rooms',
        GUESTS_COUNT_INPUT: 'input.number_of_guests',
        AGE_SELECT_CONTAINER: '.age-control',
        AGE_TEMPLATE_SELECTOR: '.html-age-control',
        AGE_SELECT: '.age_text',
        TOAST_ROOM_LIMIT: '#room-limit-toast',
        BTN_ADD_ROOM: '.btn-add-room',
        BTN_REMOVE_LAST_ROOM: '.btn-minus-room',
        BTN_REMOVE_ROOM: '.btn-remove-room',
        BTN_INCREMENT: '.btn-plus',
        BTN_DECREMENT: '.btn-minus',
        QUANTITY_SELECTOR_GROUP: '.counter-group',
        ROOM_LABEL: '.label-title',
        TRAVELER_TOTAL_INPUT: 'input[name="number_of_guests"]',
        ROOM_COUNTER_ELEMENTS: '.room-display-count, input.number_of_room',
        SEARCH_SUMMARY_INPUT: 'input.resume',
        SEARCH_RESULTS_LABEL: '#search-travelers-desk .resume:not(input)',
        COLLAPSE_GUEST_SELECTOR: '#collapseGuests',
        DIVIDER: 'hr',
        PACKAGE_GUEST_LIMIT_MSG: '#package-guest-limit-message'
    };

    const CLASS = {
        HIDDEN: 'd-none'
    };

    const LIMITS = {
        adults: {
            min: MIN.ADULTS,
            max: MAX.ADULTS
        },
        children: {
            min: MIN.CHILDREN,
            max: MAX.CHILDREN
        },
        number_of_rooms: {
            min: MIN.ROOMS,
            max: MAX.ROOMS
        }
    };

    let cachedChildAgeSelectHTML = '';

    function getChildAgeSelectTemplate() {
        if (cachedChildAgeSelectHTML) return cachedChildAgeSelectHTML;

        const template = document.querySelector(SELECTORS.AGE_TEMPLATE_SELECTOR);
        if (template?.innerHTML.trim()) {
            return (cachedChildAgeSelectHTML = template.innerHTML.trim());
        }

        const select = document.querySelector(`${SELECTORS.ROOM_SELECTION_CARD} ${SELECTORS.AGE_SELECT_CONTAINER} select`);
        return (cachedChildAgeSelectHTML = select?.outerHTML || '');
    }

    function getChildCount(roomCard) {
        const childInput = roomCard.querySelector(SELECTORS.CHILD_INPUT);
        return childInput ? parseInt(childInput.value || 0) : 0;
    }
    
    function getAgeContainer(roomCard) {
        return roomCard.querySelector(SELECTORS.AGE_SELECT_CONTAINER);
    }
    
    function getAges(roomCard) {
        const agesString = roomCard.getAttribute('data-children-ages');
        if (!agesString) return [];
        try {
            return JSON.parse(agesString);
        } catch {
            return [];
        }
    }
    
    function createAgeSelect(age) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = getChildAgeSelectTemplate();
    
        const select = wrapper.querySelector('select');
        
        if (!select) return null;
    
        Array.from(select.options).forEach(opt => {
            opt.defaultSelected = (parseInt(opt.value) === (age !== undefined ? parseInt(age) : 6));
        });
    
        return select;
    }
    
    function removeExtraAgeSelectors(ageContainer, countToKeep) {
        Array.from(ageContainer.children).slice(countToKeep).forEach(el => el.remove());
        if (countToKeep < 1) {
            ageContainer.closest(SELECTORS.AGE_SELECT).classList.add('d-none')
            ageContainer.closest(SELECTORS.ROOM_SELECTION_CARD).setAttribute('data-children-ages', '[]')
        } 
    }
    
    function syncChildAgeSelectors(roomCard) {
        const childCount = getChildCount(roomCard);
        const ageContainer = getAgeContainer(roomCard);
        if (!ageContainer) return;
        if (childCount > 0) {
            ageContainer.closest(SELECTORS.AGE_SELECT).classList.remove('d-none')
        }
        const current = ageContainer.children.length;
        const ages = getAges(roomCard);
    
        if (childCount < current) {
            removeExtraAgeSelectors(ageContainer, childCount);
        } else {
            const fragment = document.createDocumentFragment();
            for (let i = current; i < childCount; i++) {
                const select = createAgeSelect(ages[i]);
                if (select) fragment.appendChild(select);
            }
            ageContainer.appendChild(fragment);
        }
    } 

    function formatTravelerSummary(roomCount, guestCount) {
        const roomText = Number(roomCount) === 1 ? 'quarto' : 'quartos';
        const guestText = Number(guestCount) === 1 ? 'hóspede' : 'hóspedes';
        return `${String(roomCount).padStart(2, '0')} ${roomText} para ${String(guestCount).padStart(2, '0')} ${guestText}`;
    }

    function applyTravelerSummary(roomCount, guestCount, searchWidgetWrapper) {
        const summaryText = formatTravelerSummary(roomCount, guestCount);
    
        searchWidgetWrapper.querySelectorAll(SELECTORS.TRAVELER_TOTAL_INPUT).forEach((totalGuestsInput) => {
            totalGuestsInput.value = guestCount;
        });
    
        searchWidgetWrapper.querySelectorAll(SELECTORS.ROOM_COUNTER_ELEMENTS).forEach((roomCountElement) => {
            const val = String(roomCount).padStart(2, '0');
            roomCountElement.tagName === 'INPUT' ? (roomCountElement.value = val) : (roomCountElement.textContent = val);
        });
    
        const hiddenRoomInput = searchWidgetWrapper.querySelector(SELECTORS.ROOM_COUNT_INPUT);
        if (hiddenRoomInput) hiddenRoomInput.value = String(roomCount).padStart(2, '0');
    
        const guestsBlock = searchWidgetWrapper.closest('.guests') || searchWidgetWrapper;
        guestsBlock.querySelectorAll(SELECTORS.SEARCH_SUMMARY_INPUT).forEach((summaryInput) => {
            summaryInput.value = summaryText;
        });
    
        guestsBlock.querySelectorAll('.resume:not(input)').forEach((resumeLabelElement) => {
            resumeLabelElement.textContent = summaryText;
        });
    }

    function updateTravelerSummary(guestFormContainer, searchWidgetWrapper) {
        const rooms = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD);
        let totalAdults = 0,
            totalChildren = 0;
    
        rooms.forEach(room => {
            const adults = parseInt(room.querySelector(SELECTORS.ADULT_INPUT)?.value || 0, 10);
            const children = parseInt(room.querySelector(SELECTORS.CHILD_INPUT)?.value || 0, 10);
    
            totalAdults += adults;
            totalChildren += children;
        });
    
        const totalGuests = totalAdults + totalChildren;
        const totalRooms = rooms.length;
    
        applyTravelerSummary(totalRooms, totalGuests, searchWidgetWrapper);
    }

    function getTotalGuestsInForm(guestFormContainer) {
        const rooms = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD);
        let total = 0;
        rooms.forEach((room) => {
            total += parseInt(room.querySelector(SELECTORS.ADULT_INPUT)?.value || 0, 10);
            total += parseInt(room.querySelector(SELECTORS.CHILD_INPUT)?.value || 0, 10);
        });
        return total;
    }

    function serializeGuestOccupation(guestFormContainer) {
        const serializedGuestRooms = [];
        guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).forEach((room) => {
            serializedGuestRooms.push({
                adults: parseInt(room.querySelector(SELECTORS.ADULT_INPUT)?.value || 0, 10),
                children: parseInt(room.querySelector(SELECTORS.CHILD_INPUT)?.value || 0, 10),
                ages: getAges(room) || []
            });
        });
        return serializedGuestRooms;
    }

    function rebindGuestChildTooltips(guestFormContainer) {
        guestFormContainer.querySelectorAll(SELECTORS.CHILD_TOOLTIP).forEach((tooltipElement) => {
            const existingTooltip = bootstrap.Tooltip.getInstance(tooltipElement);
            if (existingTooltip) existingTooltip.dispose();
            if (typeof bootstrap !== "undefined" && bootstrap.Tooltip) {
                new bootstrap.Tooltip(tooltipElement);
            }
        });
    }

    function syncGuestFormInnerHTMLToPeer(sourceGuestForm, targetGuestForm, targetSearchWidgetWrapper) {
        if (sourceGuestForm === targetGuestForm) return;
        targetGuestForm.innerHTML = sourceGuestForm.innerHTML;
        rebindGuestChildTooltips(targetGuestForm);
        updateRoomSearchState(targetGuestForm, targetSearchWidgetWrapper);
        const sourceSearchWidgetWrapper = sourceGuestForm.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
        if (sourceSearchWidgetWrapper) {
            applyPackageGuestCap(sourceGuestForm, sourceSearchWidgetWrapper);
        }
    }

    function syncPeerGuestFormFrom(sourceGuestForm) {
        const allGuestFormContainers = document.querySelectorAll(SELECTORS.GUEST_FORM_CONTAINER);
        if (allGuestFormContainers.length < 2) return;
        const peerGuestForm = sourceGuestForm === allGuestFormContainers[0]
            ? allGuestFormContainers[1]
            : allGuestFormContainers[0];
        const peerSearchWidgetWrapper = peerGuestForm.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
        if (peerSearchWidgetWrapper) {
            syncGuestFormInnerHTMLToPeer(sourceGuestForm, peerGuestForm, peerSearchWidgetWrapper);
        }
    }

    function markPackageGuestsDirtyIfNeeded() {
        if (
            kombi.searchTabs &&
            typeof kombi.searchTabs.isPackageActive === "function" &&
            kombi.searchTabs.isPackageActive()
        ) {
            kombi._packageGuestsDirty = true;
        }
    }

    function resetGuestFormToPackageDefault(guestFormContainer, searchWidgetWrapper) {
        const roomCardElements = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD);
        for (let i = roomCardElements.length - 1; i > 0; i--) {
            roomCardElements[i].remove();
        }
        const firstRoomCard = guestFormContainer.querySelector(SELECTORS.ROOM_SELECTION_CARD);
        if (firstRoomCard) {
            firstRoomCard.setAttribute("data-children-ages", "[]");
            firstRoomCard.querySelector(SELECTORS.ADULT_INPUT).value = "02";
            firstRoomCard.querySelector(SELECTORS.CHILD_INPUT).value = "00";
            const ageSelectContainer = firstRoomCard.querySelector(SELECTORS.AGE_SELECT_CONTAINER);
            if (ageSelectContainer) ageSelectContainer.innerHTML = "";
            firstRoomCard.querySelector(SELECTORS.AGE_SELECT).classList.add(CLASS.HIDDEN);
            syncChildAgeSelectors(firstRoomCard);
        }
        rebindGuestChildTooltips(guestFormContainer);
        updateRoomSearchState(guestFormContainer, searchWidgetWrapper);
    }

    function applySerializedGuestOccupation(guestFormContainer, searchWidgetWrapper, occupation) {
        if (!Array.isArray(occupation) || !occupation.length) return;
        const existingRoomCards = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD);
        for (let i = existingRoomCards.length - 1; i >= 0; i--) {
            if (i >= occupation.length) {
                existingRoomCards[i].remove();
            }
        }
        for (let i = 0; i < occupation.length; i++) {
            let roomCard = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD)[i];
            if (!roomCard) {
                const lastRoomCard = guestFormContainer.querySelector(
                    `${SELECTORS.ROOM_SELECTION_CARD}:last-child`
                );
                if (!lastRoomCard) return;
                const clonedRoomCard = lastRoomCard.cloneNode(true);
                const tooltipInClone = clonedRoomCard.querySelector(SELECTORS.CHILD_TOOLTIP);
                if (tooltipInClone) {
                    const oldTooltip = bootstrap.Tooltip.getInstance(tooltipInClone);
                    if (oldTooltip) oldTooltip.dispose();
                    new bootstrap.Tooltip(tooltipInClone);
                }
                guestFormContainer.appendChild(clonedRoomCard);
                initializeRoomCardFields(clonedRoomCard, false);
                roomCard = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD)[i];
            }
            const roomOccupation = occupation[i];
            const childAges = roomOccupation.ages || [];
            roomCard.setAttribute("data-children-ages", JSON.stringify(childAges));
            roomCard.querySelector(SELECTORS.ADULT_INPUT).value = String(roomOccupation.adults).padStart(2, "0");
            roomCard.querySelector(SELECTORS.CHILD_INPUT).value = String(roomOccupation.children).padStart(2, "0");
            syncChildAgeSelectors(roomCard);
        }
        rebindGuestChildTooltips(guestFormContainer);
        updateRoomSearchState(guestFormContainer, searchWidgetWrapper);
    }

    /**
     * Package tab: cap total guests at MAX.PACKAGE_GUESTS; toggle message and disable + / add-room when capped.
     */
    function applyPackageGuestCap(guestFormContainer, searchWidgetWrapper) {
        const msg = searchWidgetWrapper.querySelector(SELECTORS.PACKAGE_GUEST_LIMIT_MSG);
        const isPackage =
            kombi.searchTabs &&
            typeof kombi.searchTabs.isPackageActive === "function" &&
            kombi.searchTabs.isPackageActive();

        if (!isPackage) {
            if (msg) msg.classList.add(CLASS.HIDDEN);
            guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).forEach((room) => {
                room.querySelectorAll(SELECTORS.QUANTITY_SELECTOR_GROUP).forEach((group) => {
                    refreshQuantitySelectorGroup(group, searchWidgetWrapper);
                });
            });
            const btnPlusRoom = searchWidgetWrapper.querySelector(SELECTORS.BTN_ADD_ROOM);
            const roomCount = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).length;
            if (btnPlusRoom) btnPlusRoom.disabled = roomCount >= MAX.ROOMS;
            return;
        }

        const totalGuests = getTotalGuestsInForm(guestFormContainer);
        const capped = totalGuests >= MAX.PACKAGE_GUESTS;

        if (msg) msg.classList.toggle(CLASS.HIDDEN, !capped);

        const btnPlusRoom = searchWidgetWrapper.querySelector(SELECTORS.BTN_ADD_ROOM);
        const roomCount = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).length;
        const blockAddRoom =
            totalGuests + MIN.ADULTS > MAX.PACKAGE_GUESTS;
        if (btnPlusRoom) {
            btnPlusRoom.disabled = capped || roomCount >= MAX.ROOMS || blockAddRoom;
        }

        guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).forEach((room) => {
            room.querySelectorAll(SELECTORS.QUANTITY_SELECTOR_GROUP).forEach((group) => {
                const input = group.querySelector("input");
                if (!input || (input.name !== "adults" && input.name !== "children")) {
                    return;
                }
                refreshQuantitySelectorGroup(group, searchWidgetWrapper);
                if (capped) {
                    const inc = group.querySelector(SELECTORS.BTN_INCREMENT);
                    if (inc) inc.disabled = true;
                }
            });
        });
    }

    function initializeRoomCardFields(roomCard, clearFields=false) {
        const adults = clearFields ? 2 : MIN.ADULTS;
        roomCard.querySelector(SELECTORS.ADULT_INPUT).value = String(adults).padStart(2, '0');
        roomCard.querySelector(SELECTORS.CHILD_INPUT).value = String(MIN.CHILDREN).padStart(2, '0');
        roomCard.querySelector(SELECTORS.AGE_SELECT_CONTAINER).innerHTML = '';
        if (MIN.CHILDREN < 1) {
            roomCard.querySelector(SELECTORS.AGE_SELECT).classList.add('d-none')
        }
    }

    function updateQuantityButtonState(group, fieldName, value) {
        const limits = LIMITS[fieldName];
        if (!limits) return;

        group.querySelector(SELECTORS.BTN_DECREMENT).disabled = value <= limits.min;
        group.querySelector(SELECTORS.BTN_INCREMENT).disabled = value >= limits.max;
    }

    function refreshQuantitySelectorGroup(group, searchWidgetWrapper) {
        const input = group.querySelector('input');
        if (!input) return;

        let value = parseInt(input.value || 0);
        const fieldName = input.name;

        if (fieldName === 'number_of_rooms' && searchWidgetWrapper) {
            value = parseInt(searchWidgetWrapper.querySelector(SELECTORS.ROOM_COUNT_INPUT)?.value || 0);
        }

        updateQuantityButtonState(group, fieldName, value);
    }

    function updateRoomSearchState(guestFormContainer, searchWidgetWrapper) {
        guestFormContainer.querySelectorAll(SELECTORS.DIVIDER).forEach(hr => hr.remove());

        const roomCards = Array.from(guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD));
        roomCards.forEach((roomCard, index) => {
            const roomNumber = index + 1;
            roomCard.dataset.room = roomNumber;
            roomCard.querySelector(SELECTORS.ROOM_LABEL).textContent = `Quarto ${String(roomNumber).padStart(2, '0')}`;
            roomCard.querySelector(SELECTORS.BTN_REMOVE_ROOM).classList.toggle(CLASS.HIDDEN, index === 0);

            if (index > 0) {
                const divider = document.createElement('hr');
                divider.className = 'my-3';
                guestFormContainer.insertBefore(divider, roomCard);
            }

            syncChildAgeSelectors(roomCard);
        });

        const btnMinusRoom = searchWidgetWrapper.querySelector(SELECTORS.BTN_REMOVE_LAST_ROOM);
        if (btnMinusRoom) {
            const roomCount = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).length;
            btnMinusRoom.disabled = roomCount <= MIN.ROOMS;
        }

        const btnPlusRoom = searchWidgetWrapper.querySelector(SELECTORS.BTN_ADD_ROOM);
        if (btnPlusRoom) {
            const roomCount = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).length;
            btnPlusRoom.disabled = roomCount >= MAX.ROOMS;
        }

        const roomLimitMsg = searchWidgetWrapper.querySelector('#room-limit-message');
        if (roomLimitMsg) {
            const roomCount = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).length;
            roomLimitMsg.classList.toggle('d-none', roomCount < MAX.ROOMS);
        }

        updateTravelerSummary(guestFormContainer, searchWidgetWrapper);
        refreshQuantitySelectorGroup(searchWidgetWrapper.querySelector(SELECTORS.QUANTITY_SELECTOR_GROUP), searchWidgetWrapper);
        roomCards.forEach(room => room.querySelectorAll(SELECTORS.QUANTITY_SELECTOR_GROUP).forEach(group => refreshQuantitySelectorGroup(group)));
        applyPackageGuestCap(guestFormContainer, searchWidgetWrapper);
    }

    function setupRoomSelectionForm() {
        document.querySelectorAll(SELECTORS.GUEST_FORM_CONTAINER).forEach(guestFormContainer => {
          const searchWidgetWrapper = guestFormContainer.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
          if (!searchWidgetWrapper) return;
      
          setupAddRoomButton(guestFormContainer, searchWidgetWrapper);
          setupRemoveRoomButton(guestFormContainer, searchWidgetWrapper);
          setupRoomCardInteractions(guestFormContainer, searchWidgetWrapper);
      
          updateRoomSearchState(guestFormContainer, searchWidgetWrapper);
        });
    }
      
    function setupAddRoomButton(guestFormContainer, searchWidgetWrapper) {
        const btn = searchWidgetWrapper.querySelector(SELECTORS.BTN_ADD_ROOM);
        if (!btn) return;
      
        btn.addEventListener('click', () => {
          const currentRooms = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).length;
          if (currentRooms >= MAX.ROOMS) return showRoomLimitWarningToast(searchWidgetWrapper);
          if (
              kombi.searchTabs &&
              typeof kombi.searchTabs.isPackageActive === "function" &&
              kombi.searchTabs.isPackageActive() &&
              getTotalGuestsInForm(guestFormContainer) + MIN.ADULTS > MAX.PACKAGE_GUESTS
          ) {
              return;
          }

          const lastRoomCard = guestFormContainer.querySelector(`${SELECTORS.ROOM_SELECTION_CARD}:last-child`);
          if (!lastRoomCard) return;
      
          const clonedRoomCard = lastRoomCard.cloneNode(true);
          
          if (clonedRoomCard) {
            clonedRoomCard.setAttribute('data-children-ages', '[]')
            const tooltipEl = clonedRoomCard.querySelector(SELECTORS.CHILD_TOOLTIP);
            if (tooltipEl) {
                const existingTooltip = bootstrap.Tooltip.getInstance(tooltipEl);
                if (existingTooltip) existingTooltip.dispose();
                new bootstrap.Tooltip(tooltipEl);
            }

          }
          
          initializeRoomCardFields(clonedRoomCard);
          guestFormContainer.appendChild(clonedRoomCard);
          updateRoomSearchState(guestFormContainer, searchWidgetWrapper);
          kombi._lastGuestFormSource = guestFormContainer;
          markPackageGuestsDirtyIfNeeded();
          syncPeerGuestFormFrom(guestFormContainer);
        });
    }
      
    function setupRemoveRoomButton(guestFormContainer, searchWidgetWrapper) {
        const btn = searchWidgetWrapper.querySelector(SELECTORS.BTN_REMOVE_LAST_ROOM);
        if (!btn) return;
      
        btn.addEventListener('click', () => {
          const rooms = guestFormContainer.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD);
          if (rooms.length > MIN.ROOMS) {
            rooms[rooms.length - 1].remove();
            updateRoomSearchState(guestFormContainer, searchWidgetWrapper);
            kombi._lastGuestFormSource = guestFormContainer;
            markPackageGuestsDirtyIfNeeded();
            syncPeerGuestFormFrom(guestFormContainer);
          }
        });
    }
      
    function setupRoomCardInteractions(guestFormContainer, searchWidgetWrapper) {
        guestFormContainer.addEventListener('click', e => {
          const target = e.target;
          const roomCard = target.closest(SELECTORS.ROOM_SELECTION_CARD);
          const group = target.closest(SELECTORS.QUANTITY_SELECTOR_GROUP);
      
          if (!roomCard) return;
    
          if (target.closest(SELECTORS.BTN_REMOVE_ROOM)) {
            roomCard.remove();
            updateRoomSearchState(guestFormContainer, searchWidgetWrapper);
            kombi._lastGuestFormSource = guestFormContainer;
            markPackageGuestsDirtyIfNeeded();
            syncPeerGuestFormFrom(guestFormContainer);
            return;
          }
      
          if (!group) return;
          const input = group.querySelector('input');
          if (!input) return;
      
          let val = parseInt(input.value || 0);
          const limits = LIMITS[input.name];
          if (!limits) return;
      
          if (target.closest(SELECTORS.BTN_INCREMENT) && val < limits.max) {
              if (
                  kombi.searchTabs &&
                  typeof kombi.searchTabs.isPackageActive === "function" &&
                  kombi.searchTabs.isPackageActive() &&
                  getTotalGuestsInForm(guestFormContainer) >= MAX.PACKAGE_GUESTS
              ) {
                  return;
              }
              val++;
          }
          if (target.closest(SELECTORS.BTN_DECREMENT) && val > limits.min) val--;
      
          input.value = String(val).padStart(2, '0');
      
          if (input.name === 'children') {
            syncChildAgeSelectors(roomCard);
          }
      
          updateTravelerSummary(guestFormContainer, searchWidgetWrapper);
          refreshQuantitySelectorGroup(group);
          applyPackageGuestCap(guestFormContainer, searchWidgetWrapper);
          kombi._lastGuestFormSource = guestFormContainer;
          markPackageGuestsDirtyIfNeeded();
          syncPeerGuestFormFrom(guestFormContainer);
        });
    }

    function setupGuestSelectorCollapseListener() {
        const collapseElement = document.querySelector(SELECTORS.COLLAPSE_GUEST_SELECTOR);
        if (collapseElement) {
            collapseElement.addEventListener('shown.bs.collapse', () => {
                document.querySelectorAll(SELECTORS.GUEST_FORM_CONTAINER).forEach(container => {
                    const wrapper = container.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
                    if (wrapper) updateRoomSearchState(container, wrapper);
                });
            });
        }
    }

    function initSearchWidget() {
        const roomInput = document.querySelector(SELECTORS.ROOM_COUNT_INPUT)
        const guestInput = document.querySelector(SELECTORS.GUESTS_COUNT_INPUT)
        const roomCount = roomInput ? roomInput.value : 0
        const guestCount = guestInput ? guestInput.value : 0
        const travelersSummary = document.querySelectorAll(SELECTORS.TRAVELER_SUMMARY)
        getChildAgeSelectTemplate();
        setupRoomSelectionForm();
        setupGuestSelectorCollapseListener();
        const firstGuestFormContainer = document.querySelector(SELECTORS.GUEST_FORM_CONTAINER);
        if (firstGuestFormContainer) {
            kombi._lastGuestFormSource = firstGuestFormContainer;
        }
        if (kombi._packageGuestsDirty == null) {
            kombi._packageGuestsDirty = false;
        }
        if (kombi._hotelGuestSnapshot == null) {
            kombi._hotelGuestSnapshot = null;
        }
        if (kombi.searchTabs && typeof kombi.searchTabs.isPackageActive === "function") {
            kombi._lastTabWasPackage = kombi.searchTabs.isPackageActive();
        } else {
            kombi._lastTabWasPackage = false;
        }
        const guestFormContainersOnInit = document.querySelectorAll(SELECTORS.GUEST_FORM_CONTAINER);
        if (guestFormContainersOnInit.length >= 2) {
            const desktopGuestForm = guestFormContainersOnInit[0];
            const mobileGuestForm = guestFormContainersOnInit[1];
            const desktopSearchWidgetWrapper = desktopGuestForm.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
            const mobileSearchWidgetWrapper = mobileGuestForm.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
            if (desktopSearchWidgetWrapper && mobileSearchWidgetWrapper) {
                syncGuestFormInnerHTMLToPeer(
                    desktopGuestForm,
                    mobileGuestForm,
                    mobileSearchWidgetWrapper
                );
            }
        }
        if (!kombi._searchTabChangeGuestCapBound) {
            kombi._searchTabChangeGuestCapBound = true;
            document.addEventListener("searchtab:change", function (e) {
                const isPackageTabActive = Boolean(e.detail && e.detail.isPackage);
                const previousTabWasPackage = kombi._lastTabWasPackage;
                const guestFormContainers = document.querySelectorAll(SELECTORS.GUEST_FORM_CONTAINER);
                if (guestFormContainers.length < 2) {
                    guestFormContainers.forEach(function (guestFormContainer) {
                        const searchWidgetWrapper = guestFormContainer.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
                        if (searchWidgetWrapper) {
                            updateRoomSearchState(guestFormContainer, searchWidgetWrapper);
                        }
                    });
                } else {
                    const desktopGuestForm = guestFormContainers[0];
                    const mobileGuestForm = guestFormContainers[1];
                    const desktopSearchWidgetWrapper = desktopGuestForm.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
                    const mobileSearchWidgetWrapper = mobileGuestForm.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
                    const lastEditedGuestForm = kombi._lastGuestFormSource;
                    if (
                        lastEditedGuestForm &&
                        (lastEditedGuestForm === desktopGuestForm || lastEditedGuestForm === mobileGuestForm) &&
                        desktopSearchWidgetWrapper &&
                        mobileSearchWidgetWrapper
                    ) {
                        if (lastEditedGuestForm === desktopGuestForm) {
                            syncGuestFormInnerHTMLToPeer(
                                desktopGuestForm,
                                mobileGuestForm,
                                mobileSearchWidgetWrapper
                            );
                        } else {
                            syncGuestFormInnerHTMLToPeer(
                                mobileGuestForm,
                                desktopGuestForm,
                                desktopSearchWidgetWrapper
                            );
                        }
                    } else if (desktopSearchWidgetWrapper && mobileSearchWidgetWrapper) {
                        syncGuestFormInnerHTMLToPeer(
                            desktopGuestForm,
                            mobileGuestForm,
                            mobileSearchWidgetWrapper
                        );
                    }
                    if (previousTabWasPackage === false && isPackageTabActive) {
                        if (getTotalGuestsInForm(desktopGuestForm) > MAX.PACKAGE_GUESTS) {
                            kombi._hotelGuestSnapshot = serializeGuestOccupation(desktopGuestForm);
                            kombi._packageGuestsDirty = false;
                            resetGuestFormToPackageDefault(desktopGuestForm, desktopSearchWidgetWrapper);
                            resetGuestFormToPackageDefault(mobileGuestForm, mobileSearchWidgetWrapper);
                        }
                    } else if (previousTabWasPackage === true && !isPackageTabActive) {
                        if (
                            !kombi._packageGuestsDirty &&
                            kombi._hotelGuestSnapshot &&
                            desktopSearchWidgetWrapper &&
                            mobileSearchWidgetWrapper
                        ) {
                            applySerializedGuestOccupation(
                                desktopGuestForm,
                                desktopSearchWidgetWrapper,
                                kombi._hotelGuestSnapshot
                            );
                            applySerializedGuestOccupation(
                                mobileGuestForm,
                                mobileSearchWidgetWrapper,
                                kombi._hotelGuestSnapshot
                            );
                            kombi._hotelGuestSnapshot = null;
                        }
                    }
                }
                kombi._lastTabWasPackage = isPackageTabActive;
            });
        }
        travelersSummary.forEach(function(travelerSummary) {
            applyTravelerSummary(roomCount, guestCount, travelerSummary);
        })
    }

    function updateAgeInputForRoom(room) {
      const selects = room.querySelectorAll('select.age_of_children_select');
      const ageInput = room.querySelector(SELECTORS.AGE_OF_CHILDREN);
  
      if (!ageInput) return;
  
      ageInput.value = Array.from(selects)
                            .map(sel => sel.value)
                            .filter(Boolean)
                            .join(',');
    }
  
    let dismissOpenValidationTooltip = null;

    function showTooltip(element, title) {
        if (!element) return;

        dismissOpenValidationTooltip?.();

        const existingTooltip = bootstrap.Tooltip.getInstance(element);
        if (existingTooltip) existingTooltip.dispose();

        const tooltip = new bootstrap.Tooltip(element, {
            title,
            html: true,
            trigger: "manual",
            placement: "top",
        });
        tooltip.show();

        const hideAfterClick = () => {
            dismissOpenValidationTooltip = null;
            const instance = bootstrap.Tooltip.getInstance(element);
            if (instance) instance.dispose();
        };

        dismissOpenValidationTooltip = () => {
            document.removeEventListener("click", hideAfterClick);
            dismissOpenValidationTooltip = null;
            const instance = bootstrap.Tooltip.getInstance(element);
            if (instance) instance.dispose();
        };

        document.addEventListener("click", hideAfterClick, { once: true });
    }

    function showDateRequiredTooltip(form) {
        const inputEl = form.querySelector(".calendar");
        showTooltip(inputEl, `
            <div class="fs-6">
                <strong>Preencha as datas</strong><br>
                Para uma melhor experiência, preencha as datas e realize a busca.
            </div>
        `);
    }

    function showDestinationRequiredTooltip(form) {
        const destEl =
            form.querySelector("#search-destination-package-desk") ||
            form.querySelectorAll(".search-package-fields .location-search")[1];
        showTooltip(destEl, `
            <div class="fs-6">
                <strong>Preencha o destino</strong><br>
                Para uma melhor experiência, preencha o destino e realize a busca.
            </div>
        `);
    }

    function showOriginRequiredTooltip(form) {
        const originEl =
            form.querySelector("#search-origin-package-desk") ||
            form.querySelectorAll(".search-package-fields .location-search")[0];
        showTooltip(originEl, `
            <div class="fs-6">
                <strong>Preencha a origem</strong><br>
                Para uma melhor experiência, preencha a origem e realize a busca.
            </div>
        `);
    }

    function isDateFilled(form) {
        const stayStart = form.querySelector('input[name="stay_start"]');
        return stayStart && stayStart.value && stayStart.value.trim() !== "";
    }

    function isPackageOriginFilled(form) {
        const originInput = form.querySelector('.search-package-fields input[name="origin_airport"]');
        return Boolean(originInput && originInput.value && originInput.value.trim() !== "");
    }

    function isPackageDestinationFilled(form) {
        const destInput = form.querySelector('.search-package-fields input[name="location"]');
        return Boolean(destInput && destInput.value && destInput.value.trim() !== "");
    }

    document.querySelectorAll(".SearchForm").forEach(form => {
      form.addEventListener("submit", (e) => {
        if (typeof kombi.searchTabs.syncTabInputsDisabled === "function") {
          kombi.searchTabs.syncTabInputsDisabled();
        }
        const activeTab = kombi.searchTabs.getActiveTab(form);
        const roomsInput = form.querySelector("input.room-display-count");
        const rooms = roomsInput ? parseInt(roomsInput.value, 10) : 1;

        const adultsInput = form.querySelectorAll("input[name='adults']");
        const childrenInput = form.querySelectorAll("input[name='children']");
        const adults = Array.from(adultsInput).reduce((sum, input) => {
            return sum + (parseInt(input.value) || 0);
        }, 0);
        const children = Array.from(childrenInput).reduce((sum, input) => {
            return sum + (parseInt(input.value) || 0);
        }, 0);

        const dateFilled = isDateFilled(form);
        const isHotelDefaultConfig = rooms === 1 && adults === 2 && children === 0;

        if (activeTab === "package") {
            const originFilled = isPackageOriginFilled(form);
            const destinationFilled = isPackageDestinationFilled(form);
            
            if (!originFilled) {
                showOriginRequiredTooltip(form);
                e.preventDefault();
                document.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).forEach(updateAgeInputForRoom);
                return;
            }

            if (!destinationFilled) {
                showDestinationRequiredTooltip(form);
                e.preventDefault();
                document.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).forEach(updateAgeInputForRoom);
                return;
            }

            if (!dateFilled) {
                showDateRequiredTooltip(form);
                e.preventDefault();
                document.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).forEach(updateAgeInputForRoom);
                return;
            }
        } else if (!isHotelDefaultConfig && !dateFilled) {
            showDateRequiredTooltip(form);
            e.preventDefault();
            document.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).forEach(updateAgeInputForRoom);
            return;
        }

        const submitBtn = e.submitter;
        if (submitBtn) kombi.spinner(submitBtn);
        document.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD).forEach(updateAgeInputForRoom);
      });
    });  

    function setupDropdownCloseIcon({ parentId, toggleSelector, closeIconSelector }) {
        const parent = document.getElementById(parentId);
        if (!parent) return;

        const dropdownToggle = parent.querySelector(toggleSelector);
        const closeIcon = parent.querySelector(closeIconSelector);
        if (!dropdownToggle || !closeIcon) return;

        parent.addEventListener("shown.bs.dropdown", () => {
            closeIcon.classList.remove("d-none");
        });

        parent.addEventListener("hidden.bs.dropdown", () => {
            closeIcon.classList.add("d-none");
        });
    }

    setupDropdownCloseIcon({
        parentId: "search-travelers-desk",
        toggleSelector: '[data-bs-toggle="dropdown"]',
        closeIconSelector: ".closeIcon",
    });

    setupDropdownCloseIcon({
        parentId: "search-location-desk",
        toggleSelector: '[data-bs-toggle="dropdown"]',
        closeIconSelector: ".clear-location",
    });

    setupDropdownCloseIcon({
        parentId: "search-origin-package-desk",
        toggleSelector: '[data-bs-toggle="dropdown"]',
        closeIconSelector: ".clear-location",
    });

    setupDropdownCloseIcon({
        parentId: "search-destination-package-desk",
        toggleSelector: '[data-bs-toggle="dropdown"]',
        closeIconSelector: ".clear-location",
    });

    kombi.closeNavSearchDropdowns = function (root) {
        if (!root || typeof bootstrap === "undefined" || !bootstrap.Dropdown) return;
        root.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((toggle) => {
            const dropdownInstance = bootstrap.Dropdown.getInstance(toggle);
            if (dropdownInstance) dropdownInstance.hide();
        });
    };

    kombi.closeNavSearchFlatpickrs = function (root) {
        if (!root || !kombi.flatpickrInstances) return;
        kombi.flatpickrInstances.forEach((flatpickrInstance) => {
            if (flatpickrInstance.isOpen && root.contains(flatpickrInstance.element)) {
                flatpickrInstance.close();
            }
        });
    };

    document
        .querySelectorAll(".nav-search, #SearchForm .pattern-form")
        .forEach((root) => {
            root.addEventListener("show.bs.dropdown", (e) => {
                const openingToggle = e.target?.closest?.(
                    '[data-bs-toggle="dropdown"]'
                );
                if (!openingToggle || !root.contains(openingToggle)) {
                    return;
                }
                root.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((toggle) => {
                    if (toggle !== openingToggle) {
                        const dropdownInstance = bootstrap.Dropdown.getInstance(toggle);
                        if (dropdownInstance) dropdownInstance.hide();
                    }
                });
                kombi.closeNavSearchFlatpickrs(root);
            });
        });

    document.querySelectorAll(".guests .closeIcon").forEach((icon) => {
        icon.addEventListener("click", () => {
            const allGuestFormContainers = document.querySelectorAll(SELECTORS.GUEST_FORM_CONTAINER);
            if (!allGuestFormContainers.length) return;
            const desktopGuestForm = allGuestFormContainers[0];
            const desktopSearchWidgetWrapper = desktopGuestForm.closest(SELECTORS.SEARCH_WIDGET_WRAPPER);
            if (!desktopSearchWidgetWrapper) return;
            const roomCardElements = Array.from(
                desktopGuestForm.querySelectorAll(SELECTORS.ROOM_SELECTION_CARD)
            );
            if (roomCardElements.length) {
                initializeRoomCardFields(roomCardElements[0], true);
                for (let i = 1; i < roomCardElements.length; i++) {
                    roomCardElements[i].remove();
                }
            }
            updateRoomSearchState(desktopGuestForm, desktopSearchWidgetWrapper);
            updateTravelerSummary(desktopGuestForm, desktopSearchWidgetWrapper);
            applyPackageGuestCap(desktopGuestForm, desktopSearchWidgetWrapper);
            kombi._lastGuestFormSource = desktopGuestForm;
            if (allGuestFormContainers.length > 1) {
                syncPeerGuestFormFrom(desktopGuestForm);
            }
            markPackageGuestsDirtyIfNeeded();
        });
    });

    return initSearchWidget();
};

